import { useQuery } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

import { api360 } from "./api";
import { usePermissionStore } from "../stores/permissionStore";

export type ErrorType<Error> = AxiosError<Error>;

export interface ErrorResponse {
  errors?: Error[] | null;
}

export type SearchRequest = {
  omneId?: string;
  signUpCountry?: string;
  pagination: {
    currentPage: number;
    pageSize?: number;
  };
  permission_Token?: string;
};

export const getSearchCustomer = (
  data: SearchRequest,
): Promise<AxiosResponse> => {
  const url = "/c360/v1/api/support/search-customer";
  return api360.post(url, data);
};

export const useSearchCustomer = (data: SearchRequest, enabled: boolean) => {
  return useQuery({
    queryKey: ["searchCustomer", data],
    queryFn: () => getSearchCustomer(data),
    enabled,
    retry: false,
  });
};

export const unlinkUser = (omneId: string): Promise<AxiosResponse> => {
  const url = "/c360/v1/api/support/unlink/:omneId".replace(":omneId", omneId);
  return api360.post(url, {
    permission_Token: usePermissionStore.getState().permissionToken ?? "",
  });
};

export const deleteUser = (omneId: string): Promise<AxiosResponse> => {
  const url = "/c360/v1/api/support/delete-user/:omneId".replace(
    ":omneId",
    omneId,
  );
  return api360.post(url, {
    permission_Token: usePermissionStore.getState().permissionToken ?? "",
  });
};
